import React from "react";
import PropTypes from "prop-types";
import {ASelect} from "@cisco-sbg-ui/magna-react";
import {useSelector} from "react-redux";
import {selectIncidentsOverviewLoading} from "store/selectors/incidentOverviewSelectors";
import {SEQUENTIAL_LAYOUT_ORIENTATIONS} from "utils/graph/graphStyleConstants";
import styles from "./OrientationSelectDropdown.module.scss";

const OrientationSelectDropdown = ({setOrientation}) => {
  const isLoading = useSelector(selectIncidentsOverviewLoading);

  return (
    <div className={styles.orientationSelectDropdownContainer}>
      <ASelect
        style={{maxWidth: "150px"}}
        medium
        className="mr-2"
        items={SEQUENTIAL_LAYOUT_ORIENTATIONS}
        placeholder="Orientation" // @todo: add to translation
        itemText={"name"}
        itemValue={"value"}
        onSelected={(e) => setOrientation(e.value)}
        disabled={isLoading}
      />
    </div>
  );
};

OrientationSelectDropdown.propTypes = {
  setOrientation: PropTypes.func
};

export default OrientationSelectDropdown;
